import { t } from 'i18next';

export type SidebarNavToEntityNameMapKey = keyof ReturnType<
  typeof getSidebarNavToEntityName
>;

export const getSidebarNavToEntityName = () => ({
  'sidebar-crm': t(($) => $.client, { count: 1 }),
  'sidebar-forms': 'Form',
  'sidebar-subscriptions': 'Subscription',
  'sidebar-invoices': 'Invoice',
  'sidebar-knowledgeBase': 'Article',
});

export const getShortcutActionIdsToMenuTitleMap = () => ({
  'open-client': t(($) => $.actions.open_client),
  'create-entity-command': t(($) => $.common.create),
});

export type ShortcutActionIdsToMenuTitleMapType = ReturnType<
  typeof getShortcutActionIdsToMenuTitleMap
>;

export enum KeyboardKeys {
  Esc = 'Escape',
}
